import { render, staticRenderFns } from "./NameFormText.vue?vue&type=template&id=30c4b702&scoped=true"
import script from "./NameFormText.vue?vue&type=script&lang=js"
export * from "./NameFormText.vue?vue&type=script&lang=js"
import style0 from "./NameFormText.vue?vue&type=style&index=0&id=30c4b702&prod&scoped=true&lang=css"
import style1 from "./NameFormText.vue?vue&type=style&index=1&id=30c4b702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4b702",
  null
  
)

export default component.exports